<head>
    <title></title>
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
        integrity="sha512-iecdLmaskl7CVkqkXNQ/ZH/XLlvWZOJyj7Yy7tcenmpD1ypASozpmT/E0iPtmFIB46ZmdtAc9eNBvH0H/ZpiBw=="
        crossorigin="anonymous" referrerpolicy="no-referrer" />
</head>

<app-breadcrumb *ngIf="appService.flexiFieldModule =='mainPage'"></app-breadcrumb>

<div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>

<div class="form-template" *ngIf="appService.flexiFieldModule =='mainPage'">
    <div class="row">
        <div class="col-md-4">
            <div><label for="email">Module</label></div>
            <mat-select matInput placeholder="Select" id="module" [(ngModel)]="selectedModule"
                (closed)="moduleSearchText=''" (click)="focusSearch('moduleFocusSearch')"
                (keydown.enter)="focusSearch('moduleFocusSearch')">
                <input type="search" id="moduleFocusSearch" class="dropdownsearchstyle" [(ngModel)]="moduleSearchText"
                    matInput placeholder="Search">
                <mat-option class="unselectStyle" [value]="null"
                    (onSelectionChange)="onModuleSelect($event,null);">Un-select</mat-option>
                <mat-option *ngFor="let item of moduleDropdown | assessmentSearch :moduleSearchText"
                    (onSelectionChange)="onModuleSelect($event,item)" [value]="item.valueExp">
                    {{ item.displayExp }}
                </mat-option>
            </mat-select>
        </div>
        <div class="col-md-4" [hidden]="selectedModuleValueExp == 'DOCS' || selectedModuleValueExp =='TRN'">
            <div><label for="email" *ngIf="selectedModuleValueExp !='BP'">Group</label>
                <label for="email" *ngIf="selectedModuleValueExp =='BP'">Execution Setup</label>
            </div>
            <mat-select matInput placeholder="Select" id="modules" [(ngModel)]="selectedGroup"
                (closed)="groupSearchText=''" (click)="focusSearch('groupFocusSearch')"
                (keydown.enter)="focusSearch('groupFocusSearch')">
                <input type="search" id="groupFocusSearch" class="dropdownsearchstyle" [(ngModel)]="groupSearchText"
                    matInput placeholder="Search">
                <mat-option class="unselectStyle" [value]="null"
                    (onSelectionChange)="onGroupSelect($event,null);">Un-select</mat-option>
                <mat-option *ngFor="let item of groupDropdown | assessmentSearch :groupSearchText"
                    (onSelectionChange)="onGroupSelect($event,item)" [value]="item.valueExp">
                    {{ item.displayExp }}
                </mat-option>
            </mat-select>
        </div>

    </div>
    <br>
    <div class="search-button-continer btn-align" mat-dialog-actions *ngIf="selectedModule">
        <button mat-stroked-button class="searchButton" (click)="getCall()">
            <i class="fa-solid fa-magnifying-glass"></i> Search
        </button>
    </div>
</div>
<br>
<div class="position-relative grid-content" *ngIf="selectedModule && !isCopyingFlexibleFields">
    <div>
        <div class="d-flex justify-content-between">
            <div class="d-flex align-items-center px-3">
                <div class="dropdown">
                </div>
            </div>
            <div class="d-flex gap-3">
                <div id="header-container" *ngIf="grid.length">
                    <div class="">
                        <div class="search-container">
                            <span class="fa fa-search form-control-feedback"></span>
                            <input type="text" class="form-control search_input" style="font-size: 12px"
                                placeholder="Search here..." [(ngModel)]="searchValue" />
                        </div>
                    </div>
                </div>
                <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                    *ngIf="message.dataGridAdmin && grid.length" (click)="openReorder()"
                    (keydown.enter)="openReorder()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="#ffffff">
                        <path style="fill:'#FFFFFF'"
                            d="M10 6.66666C10.8841 6.66666 11.7319 7.01785 12.357 7.64297C12.9822 8.2681 13.3333 9.11594 13.3333 10C13.3333 10.8841 12.9822 11.7319 12.357 12.357C11.7319 12.9821 10.8841 13.3333 10 13.3333C9.11596 13.3333 8.26811 12.9821 7.64299 12.357C7.01787 11.7319 6.66668 10.8841 6.66668 10C6.66668 9.11594 7.01787 8.2681 7.64299 7.64297C8.26811 7.01785 9.11596 6.66666 10 6.66666ZM10 8.33333C9.55799 8.33333 9.13406 8.50893 8.8215 8.82149C8.50894 9.13405 8.33335 9.55797 8.33335 10C8.33335 10.442 8.50894 10.8659 8.8215 11.1785C9.13406 11.4911 9.55799 11.6667 10 11.6667C10.442 11.6667 10.866 11.4911 11.1785 11.1785C11.4911 10.8659 11.6667 10.442 11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.866 8.50893 10.442 8.33333 10 8.33333ZM8.33335 18.3333C8.12501 18.3333 7.95001 18.1833 7.91668 17.9833L7.60835 15.775C7.08335 15.5667 6.63335 15.2833 6.20001 14.95L4.12501 15.7917C3.94168 15.8583 3.71668 15.7917 3.61668 15.6083L1.95001 12.725C1.89901 12.6391 1.88103 12.5376 1.89943 12.4395C1.91784 12.3413 1.97137 12.2532 2.05001 12.1917L3.80835 10.8083L3.75001 10L3.80835 9.16666L2.05001 7.80833C1.97137 7.74678 1.91784 7.65868 1.89943 7.56052C1.88103 7.46236 1.89901 7.36086 1.95001 7.275L3.61668 4.39166C3.71668 4.20833 3.94168 4.13333 4.12501 4.20833L6.20001 5.04166C6.63335 4.71666 7.08335 4.43333 7.60835 4.225L7.91668 2.01666C7.95001 1.81666 8.12501 1.66666 8.33335 1.66666H11.6667C11.875 1.66666 12.05 1.81666 12.0833 2.01666L12.3917 4.225C12.9167 4.43333 13.3667 4.71666 13.8 5.04166L15.875 4.20833C16.0583 4.13333 16.2833 4.20833 16.3833 4.39166L18.05 7.275C18.1583 7.45833 18.1084 7.68333 17.95 7.80833L16.1917 9.16666L16.25 10L16.1917 10.8333L17.95 12.1917C18.1084 12.3167 18.1583 12.5417 18.05 12.725L16.3833 15.6083C16.2833 15.7917 16.0583 15.8667 15.875 15.7917L13.8 14.9583C13.3667 15.2833 12.9167 15.5667 12.3917 15.775L12.0833 17.9833C12.05 18.1833 11.875 18.3333 11.6667 18.3333H8.33335ZM9.37501 3.33333L9.06668 5.50833C8.06668 5.71666 7.18335 6.25 6.54168 6.99166L4.53335 6.125L3.90835 7.20833L5.66668 8.5C5.33335 9.47222 5.33335 10.5278 5.66668 11.5L3.90001 12.8L4.52501 13.8833L6.55001 13.0167C7.19168 13.75 8.06668 14.2833 9.05835 14.4833L9.36668 16.6667H10.6333L10.9417 14.4917C11.9333 14.2833 12.8083 13.75 13.45 13.0167L15.475 13.8833L16.1 12.8L14.3333 11.5083C14.6667 10.5333 14.6667 9.475 14.3333 8.5L16.0917 7.20833L15.4667 6.125L13.4583 6.99166C12.8035 6.2336 11.9153 5.71473 10.9333 5.51666L10.625 3.33333H9.37501Z" />
                    </svg>
                    <span class="reload_text text-white">Settings</span>
                </div>
                <div *ngIf="!isReadOnly" class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                    (click)="openAddPopup() " (keydown.enter)="openAddPopup()">
                    <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
                    <span class="reload_text text-white">Add New</span>
                </div>
                <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                    (click)="openReport('Excel')" (keydown.enter)="openReport('Excel')" *ngIf="grid.length">
                    <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
                    <span class="reload_text text-white">Excel Report</span>
                </div>
                <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                    (click)="openReport('Pdf')" (keydown.enter)="openReport('Pdf')" *ngIf="grid.length">
                    <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
                    <span class="reload_text text-white">PDF Report</span>
                </div>
                <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                    *ngIf="message.isAuditTrailUser && grid.length" (keydown.enter)="openAuditTrail('overAll',0)"
                    (click)="openAuditTrail('overAll',0)">
                    <i class="fa-solid fa-clipboard" style="font-size:18px;color:white"></i>
                    <span class="reload_text text-white">Audit Trail</span>
                </div>
                <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center"
                    (click)="callReorderFunc()" (keydown.enter)="callReorderFunc()" matTooltip="Reorder">
                    <img src="../../../assets/img/training_module/Order.svg" width="18px" height="18px" alt="reload" />
                    <span class="reload_text">Reorder</span>
                </div>
                <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center"
                    (click)="refreshGridData()" (keydown.enter)="refreshGridData()">
                    <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reload" />
                    <span class="reload_text">Reload</span>
                </div>
            </div>
        </div>
    </div>
    <div class="align-center" *ngIf="!grid.length">
        No Data
    </div>
    <div class="table-container" *ngIf="grid.length">
        <table class="dynamic-table-container">
            <th style="min-width: 60px;background: white; text-align: center;"
                [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
                <div style="display: flex;">
                    <div>
                        <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
                    </div>
                </div>
            </th>
            <th class="grid-header-container"
                *ngFor="let oneQmsUsersDataForTable1Data of columnLists.fieldColumnarray; let ix = index;"
                [ngStyle]="{'min-width': oneQmsUsersDataForTable1Data.width,'max-width': oneQmsUsersDataForTable1Data.width,'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}"
                class="sticky-dynamic-col1">
                <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                    <span>{{ oneQmsUsersDataForTable1Data.fieldColumnarray }}</span>
                    <div class="d-flex gap-2 align-items-center">
                        <div (click)="sortColumn(columnLists.columnsListarray[ix],oneQmsUsersDataForTable1Data)"
                            (keydown.enter)="sortColumn(columnLists.columnsListarray[ix],oneQmsUsersDataForTable1Data)">
                            <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                        </div>
                    </div>
                </div>
            </th>
            <th id="menu" class="sticky-col first-col"></th>
            <tr>
                <td [class]="  makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' "></td>
                <td *ngFor=" let oneQmsUsersDataForTable1Data of columnLists.fieldColumnarray; let ix = index "
                    [ngStyle]="{ 'min-width': oneQmsUsersDataForTable1Data.width != null ? oneQmsUsersDataForTable1Data.width : '200px' }"
                    class="sticky-dynamic-col1" (mouseover)="cssFunction(0)" (focus)="focusEmpty()">
                    <div class="row-search-container"><input type="text" class="form-control" placeholder="Search"
                            (input)="applyFilter3(columnLists.columnsListarray[ix], $event)" /> </div>
                </td>
            </tr>
            <tr *ngFor="let list of pagedItems  | searchFilter : searchValue; let idx = index;">
                <td style="min-width: 60px;background: white; text-align: center;"
                    [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
                    <div style="display: flex;">
                        <div [ngClass]="list.childCheckBox ?'static_icon':'hover-menu-icons'">
                            <i class="fa-solid fa-ellipsis-vertical"></i>
                        </div>
                        <div>
                            <input type="checkbox" style="zoom: 1.2;" [checked]="list.childCheckBox"
                                (change)="onChildChanged($event, list, idx)">
                        </div>
                    </div>
                </td>
                <td id="grid-row-container" *ngFor="let key of columnLists.columnsListarray1; let i = index;"
                    class="sticky-dynamic-row1"
                    [ngStyle]="{'min-width': key.width[i],'max-width': key.width[i],'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
                    <span *ngIf="key.dataType=='CHECKBOX'">
                        <div class="gridCheckBoxes">
                            <img *ngIf="list[key.columnsListarray]" src="../../assets/img/accessSymbol.svg" alt="Yes"
                                width="20" height="20">
                            <img *ngIf="list[key.columnsListarray]==false" src="../../assets/img/noAcessSymbol.svg"
                                alt="No" width="20" height="20">

                        </div>
                    </span>
                    <span *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE'">
                        {{ list[key.columnsListarray] }}
                    </span>
                    <span *ngIf="key.dataType=='DATE'">{{ list[key.columnsListarray] }}</span>
                </td>
                <td class="sticky-col first-col">
                    <div class="action-icons">
                        <i alt="access" class="fa-solid fa-pencil" matTooltip="Edit Flexifield Setup"
                            style="margin-left: 5px;" (click)="openEditPopup(list)"
                            (keydown.enter)="openEditPopup(list)"></i>
                        <i alt="noaccess" class="fa-sharp fa-solid fa-trash" matTooltip="Delete Flexifield Setup"
                            style="margin-left: 5px;" (click)="openDeletePopup(list)"
                            (keydown.enter)="openDeletePopup(list)"></i>
                        <img *ngIf="message.isAuditTrailUser" matTooltip="Audit Trail" alt="Trail" width="20"
                            height="20" src="../../assets/img/trail-individual.svg"
                            (click)="openAuditTrail('individual',list)"
                            (keydown.enter)="openAuditTrail('individual',list)" />
                    </div>
                </td>
            </tr>
        </table>
        <div class="d-flex justify-content-center">
            <div class="width-cheat small paginationCell">
                <div class="d-flex align-items-center gap-3">
                    <div class="pagination_text mt-3">
                        {{ showingRowsText }}
                        1-{{ perPage }} of {{ collectionSize | number }}
                    </div>
                    <div>
                        <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)"
                            [disabled]="false" [collectionSize]="pager.totalItems" [(page)]="pager.currentPage"
                            [maxSize]="maxSize" [rotate]="true" [pageSize]="perPage" [ellipses]="false"
                            [boundaryLinks]="true" size="sm">
                        </ngb-pagination>
                    </div>
                    <div ngbDropdown class="mt-3">
                        <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" id="dropdownBasic1"
                            ngbDropdownToggle>
                            {{ perPage }}
                            <i class="ms-1 fa-solid fa-chevron-down"></i>
                        </button>
                        <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                            <button ngbDropdownItem (click)="paginationCall(10)">10</button>
                            <button ngbDropdownItem (click)="paginationCall(20)">20</button>
                            <button ngbDropdownItem (click)="paginationCall(50)">50</button>
                        </div>
                        per page
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #addAndEditPopup>
    <div class="ng-template-container">
        <div class="page-loading-shade" *ngIf="isProcessing">
            <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
        </div>
        <button class="close close-button" (click)="cancelAddAndEditFunction()" mat-button><i
                style="font-size: 23px;color: white;" class="fa">&#xf00d;</i></button>

        <div mat-dialog-title>
            <label for="title" class="popupTitle"> {{ popupTitle }}</label>
            <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
        </div>
        <div class="form-continer" style="max-height: 542px !important;">
            <div class="row" *ngIf="selectedUserCriteria != 'Update'">
                <mat-radio-group class="tp-radio-group" [(ngModel)]="selectedUserCriteria">
                    <mat-radio-button class="tp-radio-button" color="primary"
                        *ngFor="let criteria of searchCriteriaOptions" [value]="criteria"
                        (change)="onSearchCriteriaChanged(criteria)">
                        {{criteria}}
                    </mat-radio-button>
                </mat-radio-group>
            </div><br />

            <!-- Add new Flexible Fields -->
            <div class="row" *ngIf="dynamicLabel && selectedUserCriteria != 'Copy'">
                <div class="col-md-4">
                    <div><label for="email">Module</label></div>
                    <mat-select matInput placeholder="Select"
                        [ngClass]="{'odd-item-mat-select': oddModule == selectedModule}" [(ngModel)]="selectedModule"
                        (closed)="moduleSearchText=''" (click)="focusSearch('moduleFocusSearch')"
                        (keydown.enter)="focusSearch('moduleFocusSearch')" [disabled]=true>
                        <input type="search" id="moduleSearch" class="dropdownsearchstyle"
                            [(ngModel)]="moduleSearchText" matInput placeholder="Search">
                        <mat-option class="unselectStyle" [value]="null"
                            (onSelectionChange)="onModuleSelect($event,null);">Un-select</mat-option>
                        <mat-option *ngFor="let item of moduleDropdown | assessmentSearch :moduleSearchText"
                            (onSelectionChange)="onModuleSelect($event,item)" [value]="item.valueExp">
                            {{ item.displayExp }}
                        </mat-option>
                    </mat-select>
                </div>
                <div class="col-md-4" [hidden]="selectedModuleValueExp == 'DOCS' || selectedModuleValueExp =='TRN'">
                    <!-- Group -->
                    <div><label for="email" id="popup-group-name"
                            *ngIf="selectedModuleValueExp !='BP'">{{dynamicLabel['GROUP_NAME']}}</label>
                        <label for="email" id="popup-name" *ngIf="selectedModuleValueExp =='BP'">Execution
                            Setup</label>
                        <span class="mandatory-symbol">*</span>
                    </div>
                    <mat-select matInput placeholder="Select"
                        [ngClass]="{'odd-item-mat-select': oddGroup == selectedPopupGroup}"
                        [(ngModel)]="selectedPopupGroup" (closed)="groupPopupSearchText=''"
                        (click)="focusSearch('groupPopupFocusSearch')"
                        (keydown.enter)="focusSearch('groupPopupFocusSearch')">
                        <input type="search" id="groupPopupFocusSearch" class="dropdownsearchstyle"
                            [(ngModel)]="groupPopupSearchText" matInput placeholder="Search">
                        <mat-option class="unselectStyle" [value]="null"
                            (onSelectionChange)="onPopupGroupSelect($event,null);">Un-select</mat-option>
                        <mat-option *ngFor="let item of popupGroupDropdown | assessmentSearch :groupPopupSearchText"
                            (onSelectionChange)="onPopupGroupSelect($event,item)" [value]="item.valueExp">
                            {{ item.displayExp }}
                        </mat-option>
                    </mat-select>
                </div>
                <div class="col-md-4">
                    <!-- Field Name -->
                    <div><label for="name" id="field-name">{{dynamicLabel['FIELD_NAME']}}</label><span
                            class="mandatory-symbol">*</span>
                    </div>
                    <input id="fieldName" class="input-filed-continers" type="text"
                        (ngModelChange)="onNgModelChange($event,'field-name')" [(ngModel)]="flexibleFields.fieldName">
                </div>
                <div class="col-md-8">
                    <!-- Instructions -->
                    <div><label for="instructions">{{dynamicLabel['INSTRUCTIONS']}}</label></div>
                    <textarea id="instructions" rows="4" class="input-filed-textarea" type="text"
                        [(ngModel)]="flexibleFields.instructions"></textarea>
                </div>
                <div class="col-md-4">
                    <!-- Field Type -->
                    <div><label for="fieldType" id="field-type">{{dynamicLabel['FIELD_TYPE']}}</label><span
                            class="mandatory-symbol">*</span></div>
                    <mat-select matInput placeholder="Select"
                        [ngClass]="{'odd-item-mat-select': oddFieldType == selectedFieldType}"
                        [(ngModel)]="selectedFieldType" (closed)="fieldTypeSearchText=''"
                        (click)="focusSearch('fieldTypeFocusSearch')"
                        (keydown.enter)="focusSearch('fieldTypeFocusSearch')">
                        <input type="search" id="fieldTypeFocusSearch" class="dropdownsearchstyle"
                            [(ngModel)]="fieldTypeSearchText" matInput placeholder="Search">
                        <mat-option class="unselectStyle" [value]="null"
                            (onSelectionChange)="onFieldTypeSelect($event,null);">Un-select</mat-option>
                        <mat-option *ngFor="let item of fieldTypeDropdown | assessmentSearch :fieldTypeSearchText"
                            (onSelectionChange)="onFieldTypeSelect($event,item)" [value]="item.valueExp">
                            {{ item.displayExp }}
                        </mat-option>
                    </mat-select>
                </div>
                <div class="col-md-4">
                    <!-- Data Type -->
                    <div><label for="dataType" id="data-type">{{dynamicLabel['FIELD_DATATYPE']}}</label><span
                            class="mandatory-symbol">*</span>
                    </div>

                    <mat-select matInput placeholder="Select"
                        [ngClass]="{'odd-item-mat-select': oddDataType == selectedDataType}"
                        [(ngModel)]="selectedDataType" (closed)="dataTypeSearchText=''"
                        (click)="focusSearch('dataTypeFocusSearch')"
                        (keydown.enter)="focusSearch('dataTypeFocusSearch')">
                        <input type="search" id="dataTypeFocusSearch" class="dropdownsearchstyle"
                            [(ngModel)]="dataTypeSearchText" matInput placeholder="Search">
                        <mat-option class="unselectStyle" [value]="null"
                            (onSelectionChange)="onDataTypeSelect($event,null);">Un-select</mat-option>
                        <mat-option *ngFor="let item of dataTypeDropdown | assessmentSearch :dataTypeSearchText"
                            (onSelectionChange)="onDataTypeSelect($event,item)" [value]="item.valueExp">
                            {{ item.displayExp }}
                        </mat-option>
                    </mat-select>
                </div>
                <div class="col-md-4">
                    <!-- Field Width -->
                    <div><label for="fieldWidth">{{dynamicLabel['FIELD_WIDTH']}}</label></div>
                    <input id="fieldWidth" class="input-filed-continers" type="number"
                        (keydown)="validateNumberFields($event)" [(ngModel)]="flexibleFields.fieldWidth">
                </div>
                <div class="col-md-4">
                    <!-- Field Height -->
                    <div><label for="fieldHeight">{{dynamicLabel['FIELD_HEIGHT']}}</label></div>
                    <input id="fieldHeight" class="input-filed-continers" type="number"
                        (keydown)="validateNumberFields($event)" [(ngModel)]="flexibleFields.fieldHeight">
                </div>
                <div class="col-md-4">
                    <!-- Default Value -->
                    <div><label for="defaultValue">{{dynamicLabel['FIELD_DEFAULT_VALUE']}}</label></div>
                    <input id="defaultValue" class="input-filed-continers" type="text"
                        [(ngModel)]="flexibleFields.fieldDefaultValue">
                </div>
                <div class="col-md-4">
                    <div>
                        <!-- Mapping Column -->
                        <label for="mappingCol" id="mapping-column">{{dynamicLabel['MAPPING_COLUMN']}}</label>
                        <span class="mandatory-symbol">*</span>
                    </div>

                    <mat-select matInput placeholder="Select"
                        [ngClass]="{'odd-item-mat-select': oddMappingColumn == selectedMappingColumn}"
                        [(ngModel)]="selectedMappingColumn" (closed)="mappingColumnSearchText=''"
                        (click)="focusSearch('mappingColumnFocusSearch')"
                        (keydown.enter)="focusSearch('mappingColumnFocusSearch')">
                        <input type="search" id="mappingColumnFocusSearch" class="dropdownsearchstyle"
                            [(ngModel)]="mappingColumnSearchText" matInput placeholder="Search">
                        <mat-option class="unselectStyle" [value]="null"
                            (onSelectionChange)="onMappingColumnSelect($event,null);">Un-select</mat-option>
                        <mat-option
                            *ngFor="let item of mappingColumnDropdown | assessmentSearch :mappingColumnSearchText"
                            (onSelectionChange)="onMappingColumnSelect($event,item)" [value]="item.valueExp"
                            [ngClass]="mappingColumnsList.includes(item.valueExp) ? 'available': ''">
                            {{ item.displayExp }}
                        </mat-option>
                    </mat-select>
                </div>

                <div class="col-md-4">
                    <div>
                        <!-- Mapping Column -->
                        <label for="mappingCol" id="mapping-column">{{dynamicLabel['APPEAR_FROM_STATUS']}}</label>
                    </div>
                    <mat-select matInput placeholder="Select"
                        [ngClass]="{'odd-item-mat-select': oddStatusFrom == selectedStatusFrom}"
                        [(ngModel)]="selectedStatusFrom" (closed)="statusFromTxt=''"
                        (click)="focusSearch('statusFromFocusSearch')"
                        (keydown.enter)="focusSearch('statusFromFocusSearch')">
                        <input type="search" id="statusFromFocusSearch" class="dropdownsearchstyle"
                            [(ngModel)]="statusFromTxt" matInput placeholder="Search">
                        <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
                        <mat-option *ngFor="let item of taskStatusSetupDropdown | assessmentSearch :statusFromTxt"
                            [value]="item.valueExp">
                            {{ item.displayExp }}
                        </mat-option>
                    </mat-select>
                </div>
                <div class="col-md-6"
                    *ngIf="selectedDataTypeValueExp !='Date' && selectedDataTypeValueExp !='Datetime'">
                    <!-- LOV Values -->
                    <div><label for="fieldWidth">{{dynamicLabel['FIELD_LOV_VALUES']}}</label></div>
                    <textarea rows="4" id="lovValues" class="input-filed-textarea" type="text"
                        [(ngModel)]="flexibleFields.fieldLovValues"></textarea>
                </div>
                <div class="col-md-3"
                    *ngIf="selectedDataTypeValueExp == 'Date' || selectedDataTypeValueExp == 'Datetime'">
                    <!-- LOV Values -->
                    <div><label for="fieldWidth">{{dynamicLabel['FIELD_LOV_VALUES']}}</label></div>
                    <mat-select matInput placeholder="Select" [(ngModel)]="selectedLovValue"
                        (closed)="lovValueSearchText=''" (click)="focusSearch('lovValueFocusSearch')"
                        (keydown.enter)="focusSearch('lovValueFocusSearch')">
                        <input type="search" id="lovValueFocusSearch" class="dropdownsearchstyle"
                            [(ngModel)]="lovValueSearchText" matInput placeholder="Search">
                        <mat-option class="unselectStyle" [value]="null"
                            (onSelectionChange)="lovValuesSelect($event,null);">Un-select</mat-option>
                        <mat-option *ngFor="let item of dateLovValuesDropdown | assessmentSearch :lovValueSearchText"
                            (onSelectionChange)="lovValuesSelect($event,item);" [value]="item.valueExp">
                            {{ item.displayExp }}
                        </mat-option>
                    </mat-select>
                </div>
                <div class="col-md-3"
                    *ngIf="selectedLovValue =='Current Date + n' || selectedLovValue == 'Current Date - n'">
                    <!-- LOV Values -->
                    <div><label for="fieldWidth">Number of Days</label></div>
                    <input class="input-filed-continers" type="number" min="0" [(ngModel)]="selectedDays"
                        (focusout)="onNumberOfDaysEntered(selectedDays)" />
                </div>
                <div class="col-md-6">
                    <!-- LOV Query -->
                    <div><label for="fieldHeight">{{dynamicLabel['FIELD_LOV_QUERY']}}</label></div>
                    <textarea rows="4" id="lovQuery" class="input-filed-textarea" type="text"
                        [(ngModel)]="flexibleFields.fieldLovQuery"></textarea>
                </div>
                <div class="col-md-4"
                    [hidden]="selectedModuleValueExp == 'DOCS' || selectedModuleValueExp == 'AU' || selectedModuleValueExp == 'CC'">
                    <!-- Applicable For Specific BusinessArea(s) -->
                    <div><label for="email">{{dynamicLabel['APPLICABLE_FOR_SPECIFIC_BUSINESSAREA']}}</label></div>
                    <mat-slide-toggle color="primary" [(ngModel)]="flexibleFields.applicableForSpecificBusinessArea"
                        (change)="businessAreaChange($event)">
                        <ng-container *ngIf="flexibleFields.applicableForSpecificBusinessArea; else no">
                            <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                        </ng-container>
                        <ng-template #no>
                            <span style="color: red;">No</span>
                        </ng-template>
                    </mat-slide-toggle>
                </div>
                <div class="col-md-4"
                    [hidden]="!(selectedModuleValueExp != 'DOCS' && selectedModuleValueExp != 'AU' && selectedModuleValueExp != 'CC' && flexibleFields.applicableForSpecificBusinessArea)">
                    <div>
                        <!-- Allowed BusinessArea(s) -->
                        <label for="email" id="business-area">{{dynamicLabel['ALLOWED_BUSINESSAREAS']}}</label>
                        <span class="mandatory-symbol">*</span>
                    </div>
                    <mat-select matInput multiple placeholder="Select" #allowedBusinessArea
                        [(ngModel)]="selectedBusinessArea" (closed)="allowedBusinessAreaText=''"
                        (click)="focusSearch('allowedBusinessAreaFocus')"
                        (keydown.enter)="focusSearch('allowedBusinessAreaFocus')">
                        <input type="search" id="allowedBusinessAreaFocus" class="dropdownsearchstyle"
                            [(ngModel)]="allowedBusinessAreaText" matInput placeholder="Search">
                        <div class="select-all">
                            <mat-checkbox [(ngModel)]="isAllowedBusinessAreaSelected"
                                (change)="toggleAllSelection('allowedBusinessArea')">Select All</mat-checkbox>
                        </div>
                        <mat-option
                            *ngFor="let item1 of businessAreaDropdown | multiAssessmentSearchPipe :allowedBusinessAreaText"
                            [value]="item1.valueExp" (onSelectionChange)="onAllowedBusinessAreaSelect($event, item1)">
                            {{ item1.displayExp }}
                        </mat-option>
                    </mat-select>
                </div>
                <div class="col-md-4">
                    <!-- Is Mandatory -->
                    <div><label for="isMand">{{dynamicLabel['IS_MANDATORY']}}</label></div>
                    <mat-slide-toggle color="primary" [(ngModel)]="flexibleFields.isMandatory">
                        <ng-container *ngIf="flexibleFields.isMandatory; else no">
                            <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                        </ng-container>
                        <ng-template #no>
                            <span style="color: red;">No</span>
                        </ng-template>
                    </mat-slide-toggle>
                </div>
                <div class="col-md-4">
                    <!-- Is Active? -->
                    <div><label for="isActive">{{dynamicLabel['IS_ACTIVE']}}</label></div>
                    <mat-slide-toggle color="primary" [(ngModel)]="flexibleFields.isActive">
                        <ng-container *ngIf="flexibleFields.isActive; else no">
                            <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                        </ng-container>
                        <ng-template #no>
                            <span style="color: red;">No</span>
                        </ng-template>
                    </mat-slide-toggle>
                </div>
                <div class="col-md-6" *ngIf="visibleEditButton">
                    <div>
                        <!-- Update Reason -->
                        <label for="updateReason" id="update-reason">{{dynamicLabel['UPDATE_REASON']}}</label>
                        <span class="mandatory-symbol">*</span>
                    </div>
                    <textarea id="updateReason" rows="4" class="input-filed-textarea" type="text"
                        [(ngModel)]="flexibleFields.updateReason"
                        (ngModelChange)="onNgModelChange($event,'update-reason')"></textarea>
                </div>
            </div>

            <div class="row" *ngIf="selectedUserCriteria == 'Copy'">
                <div class="col-md-4">
                    <div>
                        <label for="email">Source Module</label> <span class="mandatory-symbol">*</span>
                    </div>
                    <mat-select matInput placeholder="Select" [(ngModel)]="selectedSourceModule"
                        (closed)="moduleSearchText=''" (click)="focusSearch('moduleFocusSearch')"
                        (keydown.enter)="focusSearch('moduleFocusSearch')">
                        <input type="search" id="modulesSearch" class="dropdownsearchstyle"
                            [(ngModel)]="moduleSearchText" matInput placeholder="Search">
                        <mat-option class="unselectStyle" [value]="null"
                            (onSelectionChange)="onSourceModuleSelect($event,null);">Un-select</mat-option>
                        <mat-option *ngFor="let item of moduleDropdown | assessmentSearch :moduleSearchText"
                            (onSelectionChange)="onSourceModuleSelect($event,item)" [value]="item.valueExp">
                            {{ item.displayExp }}
                        </mat-option>
                    </mat-select>
                </div>
                <div class="col-md-4">
                    <div>
                        <label for="email">Target Module</label> <span class="mandatory-symbol">*</span>
                    </div>
                    <mat-select matInput placeholder="Select" [(ngModel)]="selectedTargetModule"
                        (closed)="moduleSearchText=''" (click)="focusSearch('moduleFocusSearch')"
                        (keydown.enter)="focusSearch('moduleFocusSearch')">
                        <input type="search" id="modulesfocus" class="dropdownsearchstyle" [(ngModel)]="moduleSearchText"
                            matInput placeholder="Search">
                        <mat-option class="unselectStyle" [value]="null"
                            (onSelectionChange)="onTargetModuleSelect($event,null);">Un-select</mat-option>
                        <mat-option *ngFor="let item of moduleDropdown | assessmentSearch :moduleSearchText"
                            (onSelectionChange)="onTargetModuleSelect($event,item)" [value]="item.valueExp">
                            {{ item.displayExp }}
                        </mat-option>
                    </mat-select>
                </div>
                <div class="col-md-4"
                    *ngIf="selectedTargetModuleValueExp != 'DOCS' && selectedTargetModuleValueExp != 'TRN'">
                    <div>
                        <label for="email" id="popup-group-name1" *ngIf="selectedTargetModuleValueExp !='BP'">
                            Target Group
                        </label>
                        <label for="email" id="popup-group-name2" *ngIf="selectedTargetModuleValueExp =='BP'">
                            Target Execution Setup
                        </label>
                        <span class="mandatory-symbol">*</span>
                    </div>
                    <mat-select matInput placeholder="Select" [(ngModel)]="selectedPopupGroup"
                        (closed)="groupPopupSearchText=''" (click)="focusSearch('groupPopupFocusSearch')"
                        (keydown.enter)="focusSearch('groupPopupFocusSearch')">
                        <input type="search" id="groupPopuppFocusSearch" class="dropdownsearchstyle"
                            [(ngModel)]="groupPopupSearchText" matInput placeholder="Search">
                        <mat-option class="unselectStyle" [value]="null" [disabled]="!selectedTargetModule"
                            (onSelectionChange)="onPopupGroupSelect($event,null);">Un-select</mat-option>
                        <mat-option *ngFor="let item of popupGroupDropdown | assessmentSearch :groupPopupSearchText"
                            (onSelectionChange)="onPopupGroupSelect($event,item)" [value]="item.valueExp">
                            {{ item.displayExp }}
                        </mat-option>
                    </mat-select>
                </div>
                <div class="col-md-12" *ngIf="grid.length">
                    <div class="position-relative grid-content" style="margin-top: 10px;">
                        <div>
                            <div class="d-flex justify-content-between">
                                <div class="d-flex align-items-center px-3">
                                    <div class="dropdown">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="table-container">
                            <span style="color:red;" *ngIf="!copyingFieldData.length">
                                Please pick the flexi field which you want to copy
                            </span>
                            <table class="dynamic-table-container" aria-describedby="table-description"
                                style="max-height: 35vh;">
                                <thead>
                                    <th style="min-width: 60px; text-align: center;"
                                        [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
                                        <div style="display: flex;">
                                            <div>
                                                <i class="fa-solid fa-ellipsis-vertical parent-menu-icons"></i>
                                            </div>
                                            <div style="margin-left: 5px;">
                                                <input type="checkbox" style="zoom: 1.2;" [(ngModel)]="parentCheckBox"
                                                    (change)="onParentChanged($event)">
                                            </div>
                                        </div>
                                    </th>
                                    <th class="grid-header-container"
                                        *ngFor="let riskTable of columnLists.fieldColumnarray; let ix = index;"
                                        [ngStyle]="{'min-width': riskTable.width,'max-width': riskTable.width,'overflow': 'hidden',
                        'text-overflow': 'ellipsis',
                        'white-space': 'nowrap'}" class="sticky-dynamic-col1" (mouseover)="cssFunction(0)"
                                        (focus)="focusEmpty()">
                                        <div
                                            class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                                            <span>{{ riskTable.fieldColumnarray }}</span>
                                            <div class="d-flex gap-2 align-items-center">
                                                <div (click)="sortColumn(columnLists.columnsListarray[ix],riskTable)"
                                                    (keydown.enter)="sortColumn(columnLists.columnsListarray[ix],riskTable)">
                                                    <img src="../../../assets/img/qms_img/sort.svg" width="9px"
                                                        height="16px" alt="sort" />
                                                </div>
                                            </div>
                                        </div>
                                    </th>
                                    <th class="sticky-col first-col menu"></th>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td
                                            [class]="  makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
                                        </td>
                                        <td *ngFor=" let oneQmsUsersDataForTable1Data of columnLists.fieldColumnarray; let ix = index "
                                            [ngStyle]="{ 'min-width': oneQmsUsersDataForTable1Data.width != null ? oneQmsUsersDataForTable1Data.width : '200px' }"
                                            class="sticky-dynamic-col1" (mouseover)="cssFunction(0)"
                                            (focus)="focusEmpty()">
                                            <div class="row-search-container"><input type="text" class="form-control"
                                                    placeholder="Search"
                                                    (input)="applyFilter3(columnLists.columnsListarray[ix], $event)" />
                                            </div>
                                        </td>
                                    </tr>
                                    <tr *ngFor="let list of pagedItems let idx = index;">
                                        <td style="min-width: 60px; text-align: center;"
                                            [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
                                            <div style="display: flex;">
                                                <div [ngClass]="list.childCheckBox ?'static_icon':'hover-menu-icons'">
                                                    <i class="fa-solid fa-ellipsis-vertical"></i>
                                                </div>
                                                <div>
                                                    <input type="checkbox" style="zoom: 1.2;"
                                                        [checked]="list.childCheckBox"
                                                        (change)="onChildChanged($event, list, idx)">
                                                </div>
                                            </div>
                                        </td>
                                        <td class="grid-row-container"
                                            *ngFor="let key of columnLists.columnsListarray1; let i = index;"
                                            class="sticky-dynamic-row1" [ngStyle]="{'min-width': key.width[i],'max-width': key.width[i],'overflow': 'hidden',
                            'text-overflow': 'ellipsis',
                            'white-space': 'nowrap'}" (mouseover)="cssFunction(i)" (focus)="focusEmpty()"
                                            (keydown.enter)="openEditPopup(list)" (click)="openEditPopup(list)">
                                            <span *ngIf="key.dataType=='CHECKBOX'">
                                                <div class="gridCheckBoxes">
                                                    <img *ngIf="list[key.columnsListarray]"
                                                        src="../../assets/img/accessSymbol.svg" alt="Yes" width="20"
                                                        height="20">
                                                    <img *ngIf="list[key.columnsListarray]==false"
                                                        src="../../assets/img/noAcessSymbol.svg" alt="No" width="20"
                                                        height="20">
                                                </div>
                                            </span>
                                            <span *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE'">{{
                                                list[key.columnsListarray] }}</span>
                                            <span *ngIf="key.dataType=='DATE'">{{ list[key.columnsListarray]
                                                }}</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="d-flex justify-content-center">
                                <div class="width-cheat small paginationCell">
                                    <div class="d-flex align-items-center gap-3">
                                        <div class="pagination_text mt-3">
                                            {{ showingRowsText }}
                                            1-{{ perPage }} of {{ collectionSize | number }}
                                        </div>
                                        <div>
                                            <ngb-pagination class="leftpadding"
                                                (pageChange)="setPage(pager.currentPage, $event)" [disabled]="false"
                                                [collectionSize]="pager.totalItems" [(page)]="pager.currentPage"
                                                [maxSize]="maxSize" [rotate]="true" [pageSize]="perPage"
                                                [ellipses]="false" [boundaryLinks]="true" size="sm">
                                            </ngb-pagination>
                                        </div>
                                        <div ngbDropdown class="mt-3">
                                            <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text"
                                                class="dropdownBasic1" ngbDropdownToggle>
                                                {{ perPage }}
                                                <i class="ms-1 fa-solid fa-chevron-down"></i>
                                            </button>
                                            <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                                                <button ngbDropdownItem (click)="paginationCall(10)">10</button>
                                                <button ngbDropdownItem (click)="paginationCall(20)">20</button>
                                                <button ngbDropdownItem (click)="paginationCall(50)">50</button>
                                            </div>
                                            per page
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
        <div *ngIf="selectedUserCriteria != 'Copy'">
            <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                (click)="addAndEditFunction(flexibleFields)" (keydown.enter)="addAndEditFunction(flexibleFields)"
                *ngIf="!visibleEditButton">
                <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
                <span class="reload_text text-white">Add New</span>
            </div>
            <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                (click)="addAndEditFunction(flexibleFields)" (keydown.enter)="addAndEditFunction(flexibleFields)"
                *ngIf="visibleEditButton">
                <i class="fas fa-user-edit" style="font-size: 18px;color: white;"></i>
                <span class="reload_text text-white">Update</span>
            </div>
        </div>
        <div *ngIf="selectedUserCriteria == 'Copy'">
            <button class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="copy()"
                [disabled]="!selectedSourceModule || !selectedTargetModule || (selectedTargetModuleValueExp != 'DOCS' && !selectedPopupGroup) || !copyingFieldData.length"
                [ngClass]="{ 'cursor-not-allowed': !selectedSourceModule || !selectedTargetModule || (selectedTargetModuleValueExp != 'DOCS' && !selectedPopupGroup) || !copyingFieldData.length }">
                <i class="fa-solid fa-copy" style="font-size:18px;color:white"></i>
                <span class="reload_text text-white">Copy</span>
            </button>
        </div>
        <button mat-stroked-button class="cancelButton" (click)="cancelAddAndEditFunction()">
            <i class="fa fa-close"></i> Cancel
        </button>
    </div>
</ng-template>

<ng-template #deletePopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelDeleteFunction()" mat-button><i
            class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle"> {{ popupTitle }}</label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div style="margin: 15px 15px;">
        <div class="form-continer">
            <div class="row">
                <div class="col-md-12">
                    <div><label for="deleteReason" id="delete-reason"> Reason for Delete</label><span
                            class="mandatory-symbol">*</span>
                    </div>
                    <textarea rows="4" class="input-filed-textarea" type="text"
                        [(ngModel)]="flexibleFields.deleteReason"
                        (ngModelChange)="onNgModelChange($event,'delete-reason')"></textarea>
                </div>
            </div>
            <br>
        </div>
        <div class="button-continer btn-align" mat-dialog-actions>
            <button mat-stroked-button class="deleteButton" (click)="deleteFunction(flexibleFields)">
                <i class="fa fa-trash"></i> Delete
            </button>
            <button mat-stroked-button class="cancelButton" (click)="cancelDeleteFunction()">
                <i class="fa fa-close"></i> Cancel
            </button>
        </div>
    </div>
</ng-template>

<ng-template #copyResultPopup>
    <div class="ng-template-container">
        <div class="page-loading-shade" *ngIf="isProcessing">
            <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
        </div>
        <button class="close close-button" (click)="cancelCopyResultPopup()" mat-button><i
                class="fa popupClose">&#xf00d;</i></button>
        <div mat-dialog-title>
            <label for="title" class="popupTitle"> Copied Flexi Field Result(s) </label>
            <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
        </div>
        <div class="table-container" style="margin: 10px;">
            <table style="max-height: 65vh;">
                <thead>
                    <th class="grid-header-container"
                        [ngStyle]="{'min-width': '100px','max-width': '300px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>Flexi Field Name</span>
                        </div>
                    </th>

                    <th class="grid-header-container"
                        [ngStyle]="{'min-width': '100px','max-width': '350px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>Result</span>
                        </div>
                    </th>

                    <th s class="sticky-col first-col menu "></th>
                </thead>
                <tbody>
                    <tr class="data-row-container" *ngFor="let r of responses; let idx = index;">
                        <td class="row-data">{{ r.field.fieldName }}</td>
                        <td class="row-data"
                            [ngStyle]=" r.response.resultType == 'S' ? {'color': 'green'} :{'color':'red'}">
                            {{ r.response.result }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
        <button mat-stroked-button class="cancelButton" (click)="cancelCopyResultPopup()">
            <i class="fa fa-close"></i> Cancel
        </button>
    </div>
</ng-template>
<ng-template #reorderPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelReorderFunction()" mat-button><i
            class="fa popupClose">&#xf00d;</i></button>

    <div mat-dialog-title>
        <label for="title" class="popupTitle"> {{title}}</label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div style="margin: 15px 15px;">
        <b>Drag and drop to reorder the flexifield sequence</b>
        <div class="table-container" style="max-height:560px;overflow-y:auto;">
            <table class="dynamic-table-container">
                <th style="width: 80px; text-align: center;overflow: hidden;text-overflow: 'ellipsis';
          white-space: 'nowrap'"> <span>Field Seq</span> <span class="grid-header-container"></span> </th>
                <th style="width: 300px; text-align: left;overflow: hidden;text-overflow: 'ellipsis';
          white-space: 'nowrap'"> <span>Name</span> <span class="grid-header-container"></span> </th>
                <th style="width: 80px; text-align: left;overflow: hidden;text-overflow: 'ellipsis';
          white-space: 'nowrap'"> <span>New Seq</span> <span class="grid-header-container"></span> </th>

                <tbody cdkDropList (cdkDropListDropped)="drop($event)">
                    <tr cdkDrag cdkDragLockAxis="y" cdkDragHandle
                        *ngFor="let question of redorderDataList, let idx = index;">
                        <td class="grid-row-container" style="text-align: center;overflow: hidden;text-overflow: 'ellipsis';
            white-space: 'nowrap'"><span>{{question.fieldSeq}}</span></td>
                        <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
             white-space: 'nowrap'"><span>{{question.fieldName}}</span></td>
                        <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
              white-space: 'nowrap'"><span>{{question.newSeq}}</span></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="button-continer" mat-dialog-actions>
            <button mat-stroked-button class="addButton" (click)="reorderFunction()">
                <i class="fa fa-redorder"></i> Reorder
            </button>
            <button mat-stroked-button class="cancelButton" (click)="cancelReorderFunction()">
                <i class="fa fa-close"></i> Cancel
            </button>
        </div>
    </div>
</ng-template>
<app-dynamic-audit-trail #dynAuditTrailPopup [auditTrail]="auditTrail"></app-dynamic-audit-trail>
<app-excel-pdf #excelPdfPopup [excelPdf]="excelPdf"></app-excel-pdf>
<app-grid-reorder #reorderPopup (valueEmitter)="onChildValueEmitted()"></app-grid-reorder>